import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class NotificationService {
  public resourceUrl = environment.SERVER_API_URL;

  constructor(protected http: HttpClient) {}

  getAllResource(req) {
    const options = createRequestOption(req); // merge
    return this.http.get(this.resourceUrl + 'res/all', {observe: 'response' });
  }
  countPushNotification(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + '/email/push-notification-marketing-summary', options , { observe: 'response' });
  }
  pushNotification(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + '/email/push-notification-marketing', options , { observe: 'response' });
  }
  getListNotification(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'api/broadcast-history/filter', options, { observe: 'response' });
  }
  getScheduleNotification(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'api/broadcast-history/scheduler/filter', options, { observe: 'response' });
  }
  cancelScheduleNotification(id) {
    return this.http.post(this.resourceUrl + 'api/broadcast-history/scheduler/cancel/' + id, {}, {observe: 'response' });
  }
  updateScheduleNotification(req) {
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'api/broadcast-history/scheduler/update/' + req.broadcastSchedulerId , options, { observe: 'response' });
  }
}
